import WentWrongIcon from "assets/icons/went_wrong.svg"
import CMSTypography, {
  fontSizes,
  fontWeights
} from "components/common/typography/CMSTypography"
import PropTypes from "prop-types"
import React from "react"

import { DEFAULT_WENT_WRONG_HEADING } from "./constants"

function WentWrong({ header, text, className, imageClassName }) {
  return (
    <div
      className={`${className} d-flex flex-column align-items-center justify-content-center flex-fill`}
    >
      <img
        src={WentWrongIcon}
        alt="went-wrong-icon"
        className={`${imageClassName} mb-1 went-wrong-img`}
      />
      <CMSTypography
        fontSize={fontSizes.small}
        fontWeight={fontWeights.semiBold}
      >
        {header}
      </CMSTypography>
      <CMSTypography fontSize={fontSizes.normal} fontWeight={fontWeights.light}>
        {text}
      </CMSTypography>
    </div>
  )
}

WentWrong.defaultProps = {
  header: DEFAULT_WENT_WRONG_HEADING,
  text: "We'll clean up and try again.",
  className: "",
  imageClassName: ""
}

WentWrong.propTypes = {
  header: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
  imageClassName: PropTypes.string
}

export default WentWrong
